import { gql } from '@apollo/client';

export const UTILITY_FRAGMENT = gql`
  fragment UtilityData on Utility {
    id
    displayName
    funnelTrack
    forgotPassword
    registerForAccount
    state {
      abbreviation
      id
      name
    }
  }
`;

export const FETCH_UTILITY = gql`
  query Flex_FetchUtility($utilityId: Int!) {
    utility(id: $utilityId) {
      ...UtilityData
    }
  }
  ${UTILITY_FRAGMENT}
`;
